import { GreyGrey30, GreyWhite, Flex } from '@sequencehq/core-components'
import { RevRecDashboardDateFilter } from '../revenueRecognitionDashboard/content/RevRecDashboardDateFilter'
import { startOfYear } from '@sequencehq/utils/dates'
import { RevRecDashboardCurrencyFilter } from '../revenueRecognitionDashboard/content/RevRecDashboardCurrencyFilter'
import { RevRecHeader } from '../common/RevRecHeader'

export const OverviewHeader = () => {
  return (
    <>
      <RevRecHeader>
        <RevRecHeader.Breadcrumbs route="overview" />
      </RevRecHeader>
      <Flex
        height="48px"
        paddingLeft="16px"
        paddingRight="16px"
        borderBottom="1px solid"
        borderColor={GreyGrey30}
        backgroundColor={GreyWhite}
        justifyContent="flex-start"
        alignItems="center"
      >
        <Flex gap="8px" alignItems="center">
          <RevRecDashboardDateFilter
            defaultDateRange={[startOfYear(new Date()), new Date()]}
          />
          <RevRecDashboardCurrencyFilter />
        </Flex>
      </Flex>
    </>
  )
}
